import React, {Component,Suspense,lazy} from 'react';
import { connect } from 'react-redux';
import {Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import {Container} from 'reactstrap';
import CustomHeader from '../../components/CustomHeader';
import PhoenixFooter from '@lesofi/phoenix-react-js/lib/PhoenixFooter'
import ErrorBoundary from '@lesofi/phoenix-react-js/lib/ErrorBoundary'
import Spinner from '@lesofi/phoenix-react-js/lib/Spinner'
import Analytics from 'react-router-ga'

import * as actions from '@lesofi/phoenix-sdk-js/lib/admin/redux/auth/actions'

const TaskDists = lazy(()=> import('../../components/TaskDistsRewrap'))
const TaskBatchRuns = lazy(()=> import('../../components/TaskBatchRunsRewrap'))
const TaskBatchResultsets = lazy(()=> import('../../components/TaskBatchResultsetsRewrap'))
const TaskResultsetLineItems = lazy(()=> import('../../components/TaskResultsetLineItemsRewrap'))

const PrivateRoute = ({component: Component, authed, ...rest}) => {  
  return (    
       <Route {...rest} render={(props) => authed === true 
         ? <Component {...props} /> 
         : <Redirect to={{pathname: '/login', state: {from: props.location }}} />} />  
  )
}

const LoginWithTAC = lazy(()=> import('../../components/LoginTacRewrap') ) 
const GoogleLogin = lazy(()=> import('../../components/GoogleLoginRewrap'))

const isLoggedIn = props => {
  const { auth } = props;
  
  if (auth.user ){
    return true;
  } else {
    return false;
  }
}

const Full=props=>{
  return (
    <Router>
      <div className="app">
        <CustomHeader profile={props.auth.profile} logout={props.logout} />
        <div className="app-body">
          <main className="main">
            <Container>
              <Analytics id="UA-93381200-3">
                <ErrorBoundary fallback={<div className='container'><div><p>Something went wrong</p></div></div>}>
                  <Suspense fallback={<Spinner />}>
                    <Switch>
                      <Route path="/login" name="Login" component={GoogleLogin}/> 
                      <Route path="/loginWithTAC" name="Login" component={LoginWithTAC}/> 
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/' component = {TaskDists} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskBatchRuns/:taskType/:workflowType/:crowdGroupId' component = {TaskBatchRuns} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskBatchResultsets/:runId' component = {TaskBatchResultsets} />
                      <PrivateRoute authed={isLoggedIn(props)} exact={true} path='/taskResultsetLineItems/:resultsetId' component = {TaskResultsetLineItems} />
                      <Route render={() => (
                            <div className='container'>
                              <div className='row'>
                                  <h3>Are we lost or what?</h3>
                              </div> 
                            </div>
                      )}/>
                    </Switch>
                  </Suspense>  
                </ErrorBoundary> 
              </Analytics>
            </Container>  
          </main>
        </div>
        <PhoenixFooter />
      </div>
    </Router>  
  )
}

const mapStateToProps = (state) => {
  return state;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {
      dispatch(actions.logout())
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js